import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const lpaCashOfficeQuestionsState = atom({
  key: 'lpaCashOfficeQuestionsState',
  default: {
    LPAQuestions: [],
  },
  effects_UNSTABLE: [persistAtom],
});

